import './CardHeader.scss'

const CardHeader = ({headline, hint}) => {
    return <div id="dashboard-layout-card-header">
        <div className="headline">{headline}</div>
        <div className="hint">{hint}</div>
    </div>
}

export default CardHeader